
import { Component, Vue } from "vue-property-decorator";

@Component
export default class FormLoginLine extends Vue {
  private clickLineButton() {
    this.$router.push({
      path: "/line-auth",
      query: {
        from: this.getReturnPath(),
      },
    });
  }

  // ログイン画面にredirectパラメータがある場合は、LINEログイン後にそちらへ戻す
  private getReturnPath(): string {
    let redirect = this.$route.query.redirect;
    if (Array.isArray(redirect)) {
      redirect = redirect[0];
    }
    if (
      typeof redirect === "string" &&
      redirect.startsWith("/") &&
      !redirect.startsWith("//")
    ) {
      return redirect;
    }
    return this.$route.fullPath;
  }
}
